import React, { useRef } from 'react';
import { cardBackground, cardTextColor } from '../../lib/utils';

/**
 * Editor visual de posición/tamaño del logo en la tarjeta.
 * Arrastra el logo para moverlo + slider para el tamaño. Preview en vivo.
 * Props: logoUrl, color, x, y, scale, onChange({x,y,scale})
 */
export default function LogoPlacer({ logoUrl, color, x = 50, y = 66, scale = 72, onChange }) {
  const ref = useRef(null);
  const dragging = useRef(false);
  const tc = cardTextColor(color, '#1A1A1A');

  const clamp = (n) => Math.max(0, Math.min(100, n));
  const moveTo = (clientX, clientY) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const nx = clamp(((clientX - r.left) / r.width) * 100);
    const ny = clamp(((clientY - r.top) / r.height) * 100);
    onChange({ x: Math.round(nx), y: Math.round(ny), scale });
  };
  const onDown = (e) => { dragging.current = true; e.currentTarget.setPointerCapture?.(e.pointerId); moveTo(e.clientX, e.clientY); };
  const onMove = (e) => { if (dragging.current) moveTo(e.clientX, e.clientY); };
  const onUp = () => { dragging.current = false; };

  return (
    <div>
      <div
        ref={ref}
        onPointerDown={onDown}
        onPointerMove={onMove}
        onPointerUp={onUp}
        onPointerLeave={onUp}
        style={{
          position: 'relative', width: 180, height: 300, borderRadius: 20, overflow: 'hidden',
          background: cardBackground(color || '#1A1A1A'), cursor: 'move', touchAction: 'none',
          userSelect: 'none', margin: '0 auto', boxShadow: '0 6px 18px rgba(0,0,0,0.14)',
        }}
      >
        {logoUrl ? (
          <img
            src={logoUrl}
            alt="logo"
            style={{
              position: 'absolute', left: `${x}%`, top: `${y}%`, transform: 'translate(-50%, -50%)',
              width: `${scale}%`, height: '40%', objectFit: 'contain', objectPosition: 'center',
              pointerEvents: 'none',
            }}
          />
        ) : (
          <div style={{
            position: 'absolute', left: `${x}%`, top: `${y}%`, transform: 'translate(-50%, -50%)',
            color: tc, fontSize: 12, opacity: 0.7, pointerEvents: 'none',
          }}>
            (sin logo)
          </div>
        )}
      </div>

      <div style={{ marginTop: 12 }}>
        <label style={{ fontSize: 12, color: '#6B6B70', display: 'block', marginBottom: 4 }}>
          Tamaño del logo: {scale}%
        </label>
        <input
          type="range" min="20" max="120" value={scale}
          onChange={(e) => onChange({ x, y, scale: Number(e.target.value) })}
          style={{ width: '100%' }}
        />
      </div>
      <p style={{ fontSize: 11, color: '#A1A1A6', marginTop: 4 }}>
        Arrastra el logo para moverlo · usa el slider para el tamaño
      </p>
    </div>
  );
}
